var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadiobox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.616,
    height: 36.616,
    viewBox: "0 0 36.616 36.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_radiobox-marked",
    "data-name": "Path / radiobox-marked",
    d: "M20.308,34.955A14.647,14.647,0,1,1,34.955,20.308,14.647,14.647,0,0,1,20.308,34.955M20.308,2A18.308,18.308,0,1,0,38.616,20.308,18.308,18.308,0,0,0,20.308,2m0,9.154a9.154,9.154,0,1,0,9.154,9.154,9.154,9.154,0,0,0-9.154-9.154Z",
    transform: "translate(-2 -2)",
    fill: "red"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiobox);
export default __webpack_public_path__ + "static/media/radiobox.acbf50c35b4bb1d07ba4c4583e9917ff.svg";
export { ForwardRef as ReactComponent };